<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="top-list-toolbar">
          <div>
            <h4 class="text-primary">Invoice Payment</h4>
            <ol class="breadcrumb breadcrumb-card-header">
              <li class="breadcrumb-item">
                <a href="javascript:void(0);" @click="backParent">Invoice Payment</a>
              </li>
              <li class="breadcrumb-item active">
                <span v-if="sales.id === null">New</span>
                <span v-else>
                  {{ sales.sale_no }}
                </span>
              </li>
            </ol>
            <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
            <button type="button" @click="processPayment" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Process</button>
            <button type="button" @click="setJournal" class="btn btn-sm btn-soft-primary pull-left">Process Journal</button>
          </div>
        </div>
      </div>
    </div>
    <div class="card card-list">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <div class="float-left">
              <address class="font-13">
                  <strong class="font-24">Sales</strong>
                  <br><b  class="font-16">{{ sales.sale_no }}</b>
                  <br>{{ sales.sale_date | dateFormat('DD/MM/YYYY')}}
                  <br>{{ sales.salesman }}
                  <br><b>{{ sales.taxes }}</b>
                  <br>{{ sales.price_list }}
              </address>
            </div>
          </div>
          <div class="col-md-4">
            <div class="float-left">
              <address class="font-13">
                  <strong class="font-24">Customer</strong>
                  <br><b>{{ sales.customer.name }}</b>
                  <br>{{ sales.customer.phone }}
                  <br><b>{{ sales.customer.address}}</b>
              </address>
            </div>
          </div>
        </div>
        <hr class="mt-5 mb-5">
        <div class="row">
          <div class="col-md-4">
            <strong class="font-24">Product</strong>
            <div class="table-responsive">
              <table class="table table-item">
                <thead>
                  <th>Product</th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th>Discount</th>
                  <th>Tax</th>
                  <th>Total</th>
                </thead>
                <tbody>
                  <tr v-for="d in sales.details" :key="d.id">
                    <td><b>[{{ d.product_no }}]</b> {{ d.description }}</td>
                    <td>{{ d.qty }}</td>
                    <td>{{ d.price }}</td>
                    <td>{{ d.discount | currency }}</td>
                    <td>{{ d.tax | currency }}</td>
                    <td>{{ d.total | currency }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><b>Discount:</b></td>
                    <td>{{ sales.discount }}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><b>Tax:</b></td>
                    <td>{{ sales.tax }}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><b>Total:</b></td>
                    <td>{{ sales.total }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="col-md-8">
            <strong class="font-24">Payment</strong>
            <div class="table-responsive">
              <table class="table table-item mb-0 table-sm table-striped">
                <thead>
                  <th>Date</th>
                  <th>Method</th>
                  <th>Bank</th>
                  <th>Notes</th>
                  <th>Amount</th>
                  <th>#</th>
                </thead>
                <tbody>
                  <tr v-for="(p, index) in payment" :key="p.id">
                    <td><datetime v-model="p.payment_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime></td>
                    <td>
                      <select class="form-control" v-model="p.method_id" @change="setMethodID(index)">
                        <option v-for="m in paymentMethodList" :key="m.id" :value="m.id">{{ m.name }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="p.bank_id" class="form-control">
                        <option value="">-- Bank --</option>
                        <option v-for="b in bankList" :key="b.id" :value="b.id">{{ b.name }} - {{ b.account_no }}</option>
                      </select>
                    </td>
                    <td>
                      <input type="text" class="form-control" v-model="p.notes" />
                    </td>
                    <td><input type="text" v-model="p.price" class="form-control form-control-right" v-money="money"/></td>
                    <td>
                      <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="remove(index)"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span @click="addLine" class="link-secondary">+ Add Line ( {{ getPaymentLength }} )</span>
                    </td>
                    <td colspan="5"></td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="text-right"><b>Total:</b></td>
                    <td class="text-right">{{ getTotalPayment | currency }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="text-right"><i>Outstanding:</i>:</td>
                    <td class="text-right">{{ getOutstanding | currency }}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
      <!-- <pre>{{ paymentMethodList }}</pre> -->
    <!-- <pre>{{ sales.id }}</pre> -->
  </div>
</template>

<script>
import Axios from 'axios'
import { mapState } from 'vuex'
import { getHeader, salesPaymentUrl, salesUrl } from '../../config'
export default {
  name: 'SalePayment',
  props: ['sales', 'payment'],
  data () {
    return {
      dataPayment: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  methods: {
    async processAll () {
      await this.processPayment()
      // await this.setJournal()
    },
    async setJournal () {
      console.log('journal payment: ')
      console.log(salesUrl + '/journal-payment/' + this.sales.id)
      await Axios.get(salesUrl + '/journal-payment/' + this.sales.id, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async processPayment () {
      var obj = {}
      var loop = []
      var array = this.payment
      for (let i = 0; i < array.length; i++) {
        if (typeof array[i].id === 'undefined') {
          obj = {
            payment_no: null,
            sale_no: this.sales.sale_no,
            payment_date: array[i].payment_date,
            price: array[i].price.replace(/\./g, ''),
            method_id: array[i].method_id,
            type_id: array[i].type_id,
            bank_id: array[i].bank_id,
            notes: array[i].notes
          }
        } else {
          obj = {
            id: array[i].id,
            payment_no: array[i].payment_no,
            sale_no: this.sales.sale_no,
            payment_date: array[i].payment_date,
            price: array[i].price.replace(/\./g, ''),
            method_id: array[i].method_id,
            type_id: array[i].type_id,
            bank_id: array[i].bank_id,
            notes: array[i].notes
          }
        }
        loop.push(obj)
      }
      this.dataPayment = {
        payments: loop
      }
      await Axios.post(salesPaymentUrl + '/collection', this.dataPayment, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.setJournal()
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.backParent()
        })
        .catch(error => {
          console.log(error.response.data.message)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    setMethodID (index) {
      var pay = this.payment[index]
      var methodList = this.paymentMethodList.find(d => d.id === pay.method_id)
      if (methodList.name.toLowerCase() === 'cash') {
        pay.bank_id = ''
      }
    },
    remove (index) {
      var pay = this.sales.payments[index]
      if (pay.id) {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(salesPaymentUrl + '/' + pay.id, { headers: getHeader() })
              .then(response => {
                this.sales.payments.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      } else {
        this.sales.payments.splice(index, 1)
      }
    },
    addLine () {
      console.log()
      var obj = {
        payment_no: null,
        sale_no: this.sales.sale_no,
        payment_date: new Date().toISOString(),
        price: '0',
        method_id: null,
        type_id: null,
        bank_id: null,
        notes: null
      }
      if (this.getPaymentLength >= 3) {
        return false
      } else {
        this.payment.push(obj)
      }
    },
    backParent: function () {
      this.$emit('backClicked')
    }
  },
  computed: {
    ...mapState({
      paymentMethodList: state => state.paymentMethods.paymentMethodList,
      bankList: state => state.banks.bankList
    }),
    getOutstanding () {
      var omzet = parseFloat(this.sales.total)
      var payment = parseFloat(this.getTotalPayment)
      console.log(payment + ' - ' + omzet)
      var outstanding = omzet - payment
      return outstanding
    },
    getTotalPayment () {
      var array = this.payment
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.replace(/\./g, ''))
      }
      return sum
    },
    getPaymentLength () {
      var count = this.payment.length
      return count
    },
    getTotalDetail: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    }
  }
}
</script>
